/**
 * Public customer/business site vs platform admin surface (admin.ghalishorapp.ir).
 */
export type AppSurface = 'public' | 'platform';

export function resolveAppSurface(
  hostname: string = typeof window !== 'undefined' ? window.location.hostname : 'localhost',
  envSurface: string | undefined =
    typeof import.meta !== 'undefined' ? import.meta.env?.VITE_APP_SURFACE : undefined,
): AppSurface {
  const forced = String(envSurface ?? '')
    .trim()
    .toLowerCase();
  if (forced === 'platform' || forced === 'public') return forced;

  const host = hostname.trim().toLowerCase();
  if (host === 'admin.ghalishorapp.ir' || host.startsWith('admin.')) return 'platform';
  return 'public';
}
